export const KPI_RED_ZONE_COLOUR = '#C5000F';
export const KPI_YELLOW_ZONE_COLOUR = '#F6AD17';
export const KPI_GREEN_ZONE_COLOUR = '#39AA27';

export const KPI_METER_TYPE_ROTATION = 'rotation';

export const KPI_MIN_ROTATION = -120;
export const KPI_MAX_ROTATION = 120;


export const SMALL_KPI_ROTATION_SVG_PARAM_X_POS = 12;
export const SMALL_KPI_ROTATION_SVG_PARAM_Y_POS = 12;
export const SMALL_KPI_ROTATION_SVG_PARAM_RADIUS = 10;
export const SMALL_KPI_ROTATION_SVG_PARAM_STROKE = 3;

//
//SET SVG PARAMS FOR ROTATION METER IN MOBILE MODULE HEADER
//
export const HEADER_KPI_ROTATION_SVG_PARAM_X_POS_MOBILE = 14;
export const HEADER_KPI_ROTATION_SVG_PARAM_Y_POS_MOBILE = 14;
export const HEADER_KPI_ROTATION_SVG_PARAM_RADIUS_MOBILE = 12;
export const HEADER_KPI_ROTATION_SVG_PARAM_STROKE_MOBILE = 3;


//
//SET SVG PARAMS FOR ROTATION METER IN MODULE HEADER
//
export const HEADER_KPI_ROTATION_SVG_PARAM_X_POS = 18;
export const HEADER_KPI_ROTATION_SVG_PARAM_Y_POS = 18;
export const HEADER_KPI_ROTATION_SVG_PARAM_RADIUS = 16;
export const HEADER_KPI_ROTATION_SVG_PARAM_STROKE = 3;

//
//SET SVG PARAMS FOR DEFAULT ROTATION METER USED IN TOOLTIP AND FEEDBACK
//
export const DEFAULT_KPI_ROTATION_SVG_PARAM_X_POS = 32;
export const DEFAULT_KPI_ROTATION_SVG_PARAM_Y_POS = 32;
export const DEFAULT_KPI_ROTATION_SVG_PARAM_RADIUS = 28;
export const DEFAULT_KPI_ROTATION_SVG_PARAM_STROKE = 5;

//
//SET SVG PARAMS FOR PRIMARY ROTATION METER USED IN TOOLTIP AND FEEDBACK
//
export const PRIMARY_KPI_ROTATION_SVG_PARAM_X_POS = 40;
export const PRIMARY_KPI_ROTATION_SVG_PARAM_Y_POS = 40;
export const PRIMARY_KPI_ROTATION_SVG_PARAM_RADIUS = 36;
export const PRIMARY_KPI_ROTATION_SVG_PARAM_STROKE = 6;
/*kpiMeter:{
 x: 18,
 y: 18,
 radius: 16,
 stroke: 3,
 }*/

//METER WITH START / DEFAULT VALUE AND THE KPI LABEL
export const KPI_DISPLAY_STATE_START = 'KPI_DISPLAY_STATE_START';

//METER WITH CURRENT VALUE AND THE KPI LABEL
export const KPI_DISPLAY_STATE_CURRENT = 'KPI_DISPLAY_STATE_CURRENT';

//METER WITH CURRENT VALUE AND THE KPI LABEL
export const KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL = 'KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL';

//METER WITH CURRENT VALUE WITHOUT THE KPI LABEL
export const KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL = 'KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL';

//METER WITH UPDATED SCORE WITH KPI LABEL AND INDICATORS OF HOW YOU SCORED
export const KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED = 'KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED';

// KPI LABEL AND INDICATORS OF HOW YOU SCORED WITH NO METER
export const KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED = 'KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED';

export const RED_ASSET = "red_asset";
export const YELLOW_ASSET = "yellow_asset";
export const GREEN_ASSET = "green_asset";

export const WATERMARK_STYLES = {
    opacity: 0.08,
    position: "absolute",
    height: "80px",
    width: "80px",
    right: "10px",
    top: "5px"
};



/** WEBPACK FOOTER **
 ** ./src/constants/kpiConstants.js
 **/